import { useState } from "react";
import { useRegisterSW } from "virtual:pwa-register/react";
import { useTranslation } from "react-i18next";

import { Dialog } from "../../core/Dialog/Dialog";
import { Typography } from "../../core/Typography/Typography";
import { useStyles } from "./AppReloadPrompt.style";
import {
  TypographyVariant,
  TypographyColor,
} from "../../../constants/typography";

export const AppReloadPrompt = (): JSX.Element => {
  const [isRefreshing, setIsRefreshing] = useState(false);
  const { t } = useTranslation();
  const classes = useStyles();
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(registration) {
      console.warn(`SW Registered: ${registration}`);
    },
    onRegisterError(error) {
      console.error("SW registration error", error);
    },
  });

  const onClose = (): void => {
    setNeedRefresh(false);
  };

  const onRefresh = (): void => {
    setIsRefreshing(true);
    updateServiceWorker(true);
  };

  return (
    <Dialog
      mainAction={{
        text: isRefreshing ? t("refreshing") : t("refresh"),
        onClick: onRefresh,
        disabled: isRefreshing,
        loading: isRefreshing,
      }}
      secondAction={{
        text: t("close"),
        onClick: onClose,
        disabled: isRefreshing,
      }}
      open={needRefresh}
    >
      <div className={classes.content}>
        <Typography
          variant={TypographyVariant.BodyB3Bold}
          className={classes.title}
        >
          {t("new_version_available")}
        </Typography>
        <Typography
          variant={TypographyVariant.BodyB5Regular}
          color={TypographyColor.Silver}
        >
          {t("please_refresh_to_see_the_latest_changes")}
        </Typography>
      </div>
    </Dialog>
  );
};
